import type { MessageBookmarkRecord } from "@circle-react/types/Bookmarks";
import { Avatar } from "@circleco/compass/components/Avatar";
import { Typography } from "@circleco/compass/components/Typography";

export interface MessageProps {
  bookmark: MessageBookmarkRecord;
}

export const Message = ({ bookmark }: MessageProps) => {
  const {
    title,
    author_image: authorImage,
    author_name: authorName,
    body_text: bodyText,
  } = bookmark.bookmark_record ?? {};

  return (
    <div className="flex flex-col gap-2.5">
      <Typography variant="label-xs" truncate>
        {title}
      </Typography>
      <div className="flex items-start gap-3">
        {authorName && (
          <Avatar name={authorName} src={authorImage ?? ""} size="md" />
        )}
        <div className="flex min-w-0 flex-1 flex-col">
          <Typography variant="label-sm" truncate>
            {authorName}
          </Typography>
          <Typography
            variant="body-sm"
            color="secondary"
            className="overflow-anywhere line-clamp-2"
          >
            {bodyText}
          </Typography>
        </div>
      </div>
    </div>
  );
};
